import { httpClient } from '@alfa-bank/site-http-client';
import { DC_FORM_SENDER_APPLICATIONS_CASHBACK_CATEGORIES } from '@alfa-bank/site-dc-env-config';

import type { TCashbackResponse } from '../components/cashback/models';

export const applicationsCashbackCategoriesApi = (groupType: string | number) => {
    return httpClient.get<TCashbackResponse>(
        DC_FORM_SENDER_APPLICATIONS_CASHBACK_CATEGORIES({ groupType })
    );
};
